export default __webpack_public_path__ + "identify_body_location.4e94cde6.png";